import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { Bullets } from './components/Bullets';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { StickyCta } from './components/StickyCta';
import { Footer } from './components/Footer';
import { FloatingWhatsApp } from './components/FloatingWhatsApp';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-abyss font-body text-bone" data-id="element-0" data-mp="2wj8fnurpiy7c">
      <TopBar data-id="element-1" data-mp="28u5vaf5our95" />
      <Hero data-id="element-2" data-mp="28tme50nv46w6" />
      <main data-id="element-3" data-mp="28t4mkhc5agul">
        <SocialProof data-id="element-4" data-mp="28suveqfd63nb" />
        <Problem data-id="element-5" data-mp="28s2xva27hvue" />
        <Offer data-id="element-6" data-mp="23vkwmk634fmt" />
        <Solution data-id="element-7" data-mp="23vul23bheeqe" />
        <Bullets data-id="element-8" data-mp="23u9qidp62vsj" />
        <Guarantee data-id="element-9" data-mp="23ut9lxqjzq85" />
        <Faq data-id="element-10" data-mp="23ti8k5ohswkq" />
      </main>
      <Footer data-id="element-11" data-mp="3ik7jmqgv0tve" />
      <StickyCta data-id="element-12" data-mp="3ikqz80j1f669" />
      <FloatingWhatsApp data-id="element-13" data-mp="3ij65ue8glt9z" />
    </div>;
}